import type { AoSGameState, IssueSharesArgs } from '../../types';
import { debug } from '../../utils/debug';
import type { Ctx } from 'boardgame.io';
import { INVALID_MOVE } from 'boardgame.io/core';
import { validateIssueShares } from '../validators/issueSharesValidator';

/**
 * 株式発行 Move（全マップ共通）
 *
 * config で制御:
 * - maxSharesLimit: 総発行上限（デフォルト: 15、Detroit: 25）
 * - maxSharesPerTurn: 1ターン発行上限（Barbados: 1、他: undefined = 無制限）
 *
 * @param G - ゲーム状態
 * @param ctx - Boardgame.ioコンテキスト
 * @param args - 株式発行引数
 * @returns void or INVALID_MOVE
 */
export function issueSharesMove(
  { G, ctx }: { G: AoSGameState; ctx: Ctx },
  args: IssueSharesArgs
): void | typeof INVALID_MOVE {
  const playerId = ctx.currentPlayer;
  const player = G.players[playerId];

  // バリデーション
  const validation = validateIssueShares(G, ctx, args);
  if (!validation.success) {
    console.error(`[issueSharesMove] Validation failed: ${validation.error} - ${validation.message}`);
    return INVALID_MOVE;
  }

  // 株式発行処理
  const cashGained = args.issueCount * 5;

  player.sharesIssued += args.issueCount;
  player.cash += cashGained;

  // ターン発行数を記録（maxSharesPerTurn 対応）
  if (player.currentTurnSharesIssued !== undefined) {
    player.currentTurnSharesIssued += args.issueCount;
  }

  // Phase終了判定用フラグ
  player.hasExecutedIssueSharesMove = true;

  const maxSharesLimit = G.mapConfig?.maxSharesLimit ?? 15;
  debug.log(`[issueSharesMove] Player ${playerId} issued ${args.issueCount} shares, gained $${cashGained}`);
  debug.log(`[issueSharesMove] Total shares: ${player.sharesIssued}/${maxSharesLimit}, Cash: $${player.cash}`);
}
